/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Creditsamount1Inputs */

const en_creditsamount1 = /** @type {(inputs: Creditsamount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} credits`)
};

const de_creditsamount1 = /** @type {(inputs: Creditsamount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Credits`)
};

/**
* | output |
* | --- |
* | "{count} credits" |
*
* @param {Creditsamount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditsamount1 = /** @type {((inputs: Creditsamount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditsamount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditsamount1(inputs)
	return de_creditsamount1(inputs)
});
export { creditsamount1 as "creditsAmount" }